export const introduce = {
  text: `### 指标原理
  + 已实现价格是通过已实现市值/供应量计算得出的，传统市值是按照当前市场价乘以流通量进行估算的，已实现市值是通过每笔比特币供应按其最近一次移动时的价格来进行计算的`,
  height: 1290,
};